import React from 'react'

import { nonEmbeddedAttachments } from 'util/changesets'
import Attachments from 'components/Attachments'

import Header from './Header'
import Body from './Body'
import TrackingDetails from './TrackingDetails'
import { getAvatarComponent } from './util'

const ExpandedMessageContent = ({
  message,
  expandChangeset,
  currentUserId,
  isFirstMessage,
  mailboxIndicatorNeeded,
  mailboxName,
  mailboxColor,
  onOpenImage,
  onCopyLinkClick,
  onRawEmailClick,
  onPrintClick,
}) => {
  const action = message.action
  const hasAttachments = message.hasAttachments
  const isFromMerge = message.isFromMerge
  const isForward = message.isForward
  const readReceipt = message.readReceipt

  const change = action.change
  const isNote = message.isNote
  const isBodyEmpty = change.isBodyEmpty
  const filtered = nonEmbeddedAttachments(change)

  // const tos = change.to && change.to.length > 0 ? change.to : null
  const ccs = change.cc && change.cc.length > 0 ? change.cc : null
  const bccs = change.bcc && change.bcc.length > 0 ? change.bcc : null

  return (
    <React.Fragment>
      <div className="top-side" onClick={expandChangeset}>
        {getAvatarComponent({ action })}
        <div className="header-container">
          <Header
            action={action}
            currentUserId={currentUserId}
            isNote={isNote}
            isFirstMessage={isFirstMessage}
            isForward={isForward}
            hasAttachments={hasAttachments}
            isFromMerge={isFromMerge}
            hasRawEmail={message.hasRawEmail}
            onCopyLinkClick={onCopyLinkClick}
            onRawEmailClick={onRawEmailClick}
            onPrintClick={onPrintClick}
            readReceipt={readReceipt}
          />
          {!isNote &&
            mailboxIndicatorNeeded && (
              <div className="mailbox-indicator">
                <div
                  className="dot"
                  style={{ backgroundColor: mailboxColor }}
                />
                <div className="name">{mailboxName}</div>
              </div>
            )}
          {/* {!mailboxIndicatorNeeded &&
            !isNote &&
            tos && (
              <div className="to-address">
                <span>
                  To:{' '}
                  {tos
                    .map(
                      to => (to.name ? `${to.name} <${to.email}>` : to.email)
                    )
                    .sort()
                    .join(', ')}{' '}
                </span>
              </div>
            )} */}
          {(ccs || bccs) && (
            <div className="cc-and-bcc">
              {ccs && (
                <span>
                  cc:{' '}
                  {ccs
                    .map(
                      cc => (cc.name ? `${cc.name} <${cc.email}>` : cc.email)
                    )
                    .sort()
                    .join(', ')}{' '}
                </span>
              )}
              {bccs && (
                <span>
                  bcc:{' '}
                  {bccs
                    .map(
                      bcc =>
                        bcc.name ? `${bcc.name} <${bcc.email}>` : bcc.email
                    )
                    .sort()
                    .join(', ')}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="middle-side">
        <Body
          change={change}
          isForward={isForward}
          isFirstMessage={isFirstMessage}
          onOpenImage={onOpenImage}
        />
      </div>
      <div className="bottom-side">
        <Attachments
          attachments={isBodyEmpty ? change.attachments : filtered}
        />
        {isFirstMessage && <TrackingDetails />}
      </div>
    </React.Fragment>
  )
}

export default ExpandedMessageContent
